"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var actionWrappers_1 = require("./actionWrappers");
function install() {
    var originalThen = Promise.prototype.then;
    var originalCatch = Promise.prototype.catch;
    Promise.prototype.then = actionWrappers_1.wrapThen(originalThen);
    Promise.prototype.catch = actionWrappers_1.wrapCatch(originalCatch);
    return function uninstall() {
        Promise.prototype.then = originalThen;
        Promise.prototype.catch = originalCatch;
    };
}
exports.default = install;
